import React from "react";
import styled from "styled-components";

const SaffronAppIcon = (props) => {
  return (
    <Div mr={props.mr}>
      <svg
        width={props.width}
        height="auto"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M14.179 20.6816C14.2085 14.3633 14.2085 14.3633 13.8761 14.3105C12.4831 14.0892 11.5943 13.7564 10.6064 13.0862C9.27925 12.1858 8.45524 10.9573 8.124 9.38512C7.89656 8.30568 7.9761 7.36995 8.41152 6.00224C8.85787 4.60022 8.87113 4.12447 8.48549 3.34763L8.19131 2.75503L9.37274 2.33017C10.7143 1.84771 10.6916 1.84324 11.0394 2.65818C11.3828 3.46307 11.3475 4.67318 10.9427 5.96802C10.536 7.26869 10.4494 7.88253 10.5582 8.69332C10.769 10.265 11.7455 11.2804 13.4716 11.7225C14.4041 11.9614 16.7514 11.9588 17.5802 11.7181C18.4158 11.4753 19.2223 11.0069 19.6348 10.5247C20.5562 9.44788 20.7224 8.06022 20.1541 6.19018C19.6379 4.49171 19.6657 3.03213 20.2291 2.24332C20.3975 2.00764 20.3975 2.00764 21.3395 2.27396C23.0529 2.75837 22.931 2.66231 22.5831 3.25361C22.1787 3.94116 22.191 4.49995 22.6466 6.12412C23.1667 7.97819 23.1194 9.12452 22.4601 10.6436C22.0005 11.7026 20.9121 12.8278 19.8292 13.3637C18.9811 13.7833 17.5262 14.2634 17.1025 14.2634C16.6097 14.2634 16.5596 14.3264 16.6405 14.8444C16.6809 15.104 16.7166 17.9452 16.7197 21.1582L16.7254 27H15.4374H14.1494L14.179 20.6816ZM8.17755 23.7908V22.5873H10.5045H12.8314V23.7908V24.9942H10.5045H8.17755V23.7908ZM18.0551 23.7908V22.5873H20.382H22.7089V23.7908V24.9942H20.382H18.0551V23.7908ZM8.17755 19.8795V18.6761H10.5045H12.8314V19.8795V21.083H10.5045H8.17755V19.8795ZM18.0551 19.8795V18.6761H20.382H22.7089V19.8795V21.083H20.382H18.0551V19.8795ZM8.17755 15.9683V14.7648H10.5045H12.8314V15.9683V17.1718H10.5045H8.17755V15.9683ZM18.0551 15.9683V14.7648H20.382H22.7089V15.9683V17.1718H20.382H18.0551V15.9683ZM16.4531 10.4274C16.1841 9.86199 15.8224 8.97972 15.6493 8.46676L15.3345 7.53412L15.1727 8.1659C14.9789 8.92248 13.8826 11.3575 13.7395 11.3492C13.6841 11.346 13.1805 11.1091 12.6205 10.8227L11.6024 10.302L12.953 7.62173L14.3035 4.94145L15.3524 4.93901L16.4012 4.93657L17.7572 7.60383C18.503 9.07083 19.0995 10.2837 19.0828 10.2991C19.0135 10.3627 17.0378 11.4553 16.992 11.4553C16.9646 11.4553 16.7221 10.9927 16.4531 10.4274Z"
          fill="#646775"
        />
      </svg>
      
    </Div>
  );
};

export default SaffronAppIcon;

const Div = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${(props) => props.mr || "0"};
`;

const Path = styled.path`
  fill: ${(props) => props.theme.fontColorAlt};
`;
